import React from "react";
import KPICard from "./KPICard";
import { useSelector } from "react-redux";

const TrendVisualization = ({ cardDate, loading, duration }) => {
  const { role } = useSelector((state) => state.login);

  const getType = (type) => {
    if (cardDate[type]?.trend === 0) {
      return "same";
    } else if (cardDate[type]?.trend > 0) {
      return "improved";
    } else {
      return "worsened";
    }
  };
  const description = {
    flagged: {
      same: `Same as previous ${duration?.code} Days`,
      improved: `Increase vs previous ${duration?.code} Days`,
      worsened: `Decrease vs previous ${duration?.code} Days`,
    },
    timelinessOfDelivery: {
      same: `Same as previous ${duration?.code} Days`,
      improved: `Timeliness improved vs previous ${duration?.code} Days`,
      worsened: `Timeliness dropped vs previous ${duration?.code} Days`,
    },
    requests: {
      same: `Same as previous ${duration?.code} Days`,
      improved: `Increase vs previous ${duration?.code} Days`,
      worsened: `Decrease vs previous ${duration?.code} Days`,
    },
    escalations: {
      same: `Same as previous ${duration?.code} Days`,
      improved: `Increase vs previous ${duration?.code} Days`,
      worsened: `Decrease vs previous ${duration?.code} Days`,
    },
    entitiesUnderManagement: {
      same: `Same as previous ${duration?.code} Days`,
      improved: `Increase vs previous ${duration?.code} Days`,
      worsened: `Decrease vs previous ${duration?.code} Days`,
    },
    avgResolutionTime: {
      same: `Same as previous ${duration?.code} Days`,
      improved: `Improved vs previous ${duration?.code} Days`,
      worsened: `Slower vs previous ${duration?.code} Days`,
    },
  };
  const data = [
    {
      title: "Processes Flagged",
      data: `${cardDate["flagged"]?.data === 0 ? "None" : cardDate["flagged"]?.data}`,
      dataIcon: null,
      trend: {
        type:
          getType("flagged") === "same"
            ? "same"
            : getType("flagged") === "improved"
              ? "worsened-top"
              : "improve-down",
        percentage: `${Math.abs(cardDate["flagged"]?.trend)}%`,
        description: description["flagged"][getType("flagged")],
      },
      tooltip: "Number of Processes with flagged tasks",
      link: null,
    },
    {
      title: "Entities Under Management",
      data: `${cardDate["entitiesUnderManagement"]?.data} Entities`,
      dataIcon: null,
      trend: {
        type: getType("entitiesUnderManagement"),
        percentage: `${Math.abs(cardDate["entitiesUnderManagement"]?.trend)}%`,
        description:
          description["entitiesUnderManagement"][
            getType("entitiesUnderManagement")
          ],
      },
      tooltip: "Count of unique active entities you manage/support",
      link: "/entities",
    },
    {
      title: "Timeliness of Delivery",
      data: `${cardDate["timelinessOfDelivery"]?.data}%`,
      dataIcon: null,
      trend: {
        type: getType("timelinessOfDelivery"),
        percentage: `${Math.abs(cardDate["timelinessOfDelivery"]?.trend)}%`,
        description:
          description["timelinessOfDelivery"][getType("timelinessOfDelivery")],
      },
      tooltip: "% of Processes completed on time before the due date",
      link: null,
    },
    {
      title: "Process Average Resolution Time",
      data: `${cardDate["avgResolutionTime"]?.data} Days`,
      dataIcon: "pi pi-clock",
      trend: {
        type: getType("avgResolutionTime"),
        percentage: `${Math.abs(cardDate["avgResolutionTime"]?.trend)}%`,
        description:
          description["avgResolutionTime"][getType("avgResolutionTime")],
      },
      tooltip:
        "Avg. Time of Processes Resolution in days (from ‘In Progress’ to ‘Completed’)",
      link: null,
    },
    {
      title: "Requests",
      data: `${cardDate["requests"]?.data}`,
      dataIcon: null,
      trend: {
        type:
          getType("requests") === "same"
            ? "worsened-flat"
            : getType("requests") === "improved"
              ? "worsened-top"
              : "improve-down",
        percentage: `${Math.abs(cardDate["requests"]?.trend)}%`,
        description: description["requests"][getType("requests")],
      },
      tooltip: "Number of Active Requests Submitted/Received",
      link: "/requests",
    },
    ...(!["LSP_USER", "LSP_MANAGER"].includes(role)
      ? [
          {
            title: "Escalations",
            data: `${cardDate["escalations"]?.data} Cases`,
            dataIcon: null,
            trend: {
              type:
                getType("escalations") === "same"
                  ? "worsened-flat"
                  : getType("escalations") === "improved"
                    ? "worsened-top"
                    : "improve-down",
              percentage: `${Math.abs(cardDate["escalations"]?.trend)}%`,
              description: description["escalations"][getType("escalations")],
            },
            tooltip: "Number of Processes Escalated by period selected",
            link: "/escalations",
          },
        ]
      : []),
  ];

  return (
    <div className="flex flex-wrap gap-3">
      {data.map((item, index) => (
        <div className="trend_container" key={index}>
          <KPICard
            title={item.title}
            data={item.data}
            dataIcon={item.dataIcon}
            trend={item.trend}
            tooltip={item.tooltip}
            loading={loading}
            link={item.link}
          />
        </div>
      ))}
    </div>
  );
};

export default TrendVisualization;
